module.exports = __webpack_public_path__ + "img/gas3.fd237746.png";